import { LOCAL_LANGUAGE } from '@/constants/storageKey';
import { useLocation, useNavigate } from 'react-router-dom';
import { LANGUAGE_LIST } from '@/utils/languages/languageOptions';
import { useEffect } from 'react';
import dayjs from 'dayjs';

const browserLanguageSwitch = () => {
  if (typeof navigator === 'undefined') {
    return undefined;
  }

  const lang = navigator && navigator.language && navigator.language.split('-')[0];

  if (!lang) return undefined;

  switch (lang) {
    case 'ja':
      return 'ja';

    case 'ko-KR':
      return 'ko';

    case 'ko':
      return 'ko';

    case 'zh':
      return 'zh-hans';

    case 'zh-CN':
      return 'zh-hans';

    case 'zh-TW':
      return 'zh-hant';

    case 'en':
      return 'en';

    default:
      return undefined;
  }
};

const checkLangIncludes = (code) => {
  let flag = false;

  for (let i = 0; i < LANGUAGE_LIST?.length; i++) {
    const language = LANGUAGE_LIST[i];

    if (code.includes(language.language)) {
      localStorage.setItem(LOCAL_LANGUAGE, language.language);

      flag = true;

      break;
    }
  }

  return flag;
};
export function useDefaultLanguage() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const url = useLocation().pathname + '/';

  const urlLang = url.split('/')[1];

  let code;

  useEffect(() => {
    if (code && code !== urlLang && !pathname.includes('/not-found')) {
      const replacedURL = `/${code}${url}/`;

      navigate(replacedURL.replace(/\/+$/, ''));
    }
  }, [code, url, urlLang, navigate, pathname]);

  if (urlLang !== '') {
    // IN CASE : If user entered language value after site url.
    code = checkLangIncludes(urlLang) ? urlLang : undefined;
  }

  if (
    code === undefined &&
    localStorage.getItem(LOCAL_LANGUAGE) !== undefined &&
    localStorage.getItem(LOCAL_LANGUAGE) !== null
  ) {
    // Check Local Storage
    code = checkLangIncludes(localStorage.getItem(LOCAL_LANGUAGE))
      ? localStorage.getItem(LOCAL_LANGUAGE)
      : undefined;
  }

  if (code === undefined) {
    // Check Browser Language
    code = browserLanguageSwitch();
  }
  return code;
}

export const addCommaToNumber = (number) => {
  let strNumber = String(number);

  let parts = strNumber.split('.');

  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return parts.join('.');
};

export const removeCommaFromNumber = (number) => {
  if (number === null) {
    return null;
  }

  if (number === '') {
    return null;
  }

  return Number(number.replaceAll(',', ''));
};

export function changePrimaryFontFamily() {
  const lang = localStorage.getItem(LOCAL_LANGUAGE);

  switch (lang) {
    case 'en':
      return "'Noto Sans', sans-serif";

    case 'ko':
      return "'Noto Sans KR', sans-serif";

    case 'ja':
      return "'Noto Sans JP', sans-serif";

    case 'zh-hant':
      return "'Noto Sans SC', sans-serif";

    case 'zh-hans':
      return "'Noto Sans SC', sans-serif";

    default:
      return "'Noto Sans', sans-serif";
  }
}

export function changeSecondaryFontFamily() {
  const lang = localStorage.getItem(LOCAL_LANGUAGE);

  switch (lang) {
    case 'en':
      return "'Arsenal', sans-serif";

    case 'ko':
      return "'NanumSquare', 'Noto Sans KR', sans-serif";

    case 'ja':
      return "'Noto Sans JP', sans-serif";

    case 'zh-hant':
      return "'Noto Sans SC', sans-serif";

    case 'zh-hans':
      return "'Noto Sans SC', sans-serif";

    default:
      return "'Arsenal', sans-serif";
  }
}

export function switchSlashToEmptySpace(value) {
  if (typeof value === 'string' && value.includes('://')) {
    return value;
  } else if (typeof value === 'string') {
    return value.replaceAll('//', '<wbr/>');
  }
}
export const countrySwitchLanguage = (code) => {
  switch (code) {
    case 'ko':
      return 'ko';

    case 'zh-hans':
      return 'zh';

    case 'zh-hant':
      return 'zh';

    case 'ja':
      return 'ja';

    default:
      return 'en';
  }
};

export const changeDateFormat = (date) => {
  if (date !== null && date !== '') {
    return dayjs(date).format('YYYY-MM-DD');
  } else if (date === 'Invalid Date') {
    return null;
  } else {
    return null;
  }
};

export function checkFileExtension(file) {
  // const correctForm = /(.*?)\.(jpg|jpeg|png|doc|docx|pdf|hwp)$/;
  const correctForm = ['jpg', 'jpeg', 'png', 'doc', 'docx', 'pdf', 'hwp'];
  const ext = file.name.split('.').pop().toLowerCase();

  return correctForm.includes(ext);
}

export function arenaEmailIdPerLanguage() {
  const lang = localStorage.getItem(LOCAL_LANGUAGE);

  switch (lang) {
    case 'en':
      return process.env.REACT_APP_ARENA_EMAIL_EN_ID;

    case 'ko':
      return process.env.REACT_APP_ARENA_EMAIL_KO_ID;

    case 'ja':
      return process.env.REACT_APP_ARENA_EMAIL_JA_ID;

    case 'zh-hant':
      return process.env.REACT_APP_ARENA_EMAIL_HANT_ID;

    case 'zh-hans':
      return process.env.REACT_APP_ARENA_EMAIL_HANS_ID;

    default:
      return process.env.REACT_APP_ARENA_EMAIL_INSPIRE_ID;
  }
}

export function eventEmailIdPerLanguage() {
  const lang = localStorage.getItem(LOCAL_LANGUAGE);

  switch (lang) {
    case 'en':
      return process.env.REACT_APP_EVENT_EMAIL_EN_ID;

    case 'ko':
      return process.env.REACT_APP_EVENT_EMAIL_KO_ID;

    case 'ja':
      return process.env.REACT_APP_EVENT_EMAIL_JA_ID;

    case 'zh-hant':
      return process.env.REACT_APP_EVENT_EMAIL_HANT_ID;

    case 'zh-hans':
      return process.env.REACT_APP_EVENT_EMAIL_HANS_ID;

    default:
      return process.env.REACT_APP_EVENT_EMAIL_INSPIRE_ID;
  }
}

export function getCodeName(arr, codeValue) {
  if (arr) {
    return arr?.filter((el) => el.code_value === codeValue)?.[0]?.name;
  }
}

